import * as df from 'date-fns';
import * as React from 'react';

import BooksCalendarButton from '../../../../components/books/common/buttons/BooksCalendarButton';
import * as IBooks from '../../../../interfaces/merchants/resources/books';

import css from './InputBookingDateTimeMarubatsu.module.scss';

// TODO: BooksCalendar.tsx の移植考える
import BooksCalendar from '../../../../components/books/common/calendar/BooksCalendar';

interface Props {
  loading: boolean;
  displayDates: Date[];
  events: {
    checkinTimes: string[];
    dates: { [date: string]: IBooks.DateTimeSlot };
  };
  postable: boolean;
  onSubmit: (availability: IBooks.TimeSlotAvailability) => void;
  onClickToday: () => void;
  onClickPrev: () => void;
  onClickNext: () => void;
}

class Calendar extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.handleClickCalendar = this.handleClickCalendar.bind(this);
  }

  private findEventAvailability(
    events: { [date: string]: IBooks.DateTimeSlot },
    time: number,
  ): IBooks.TimeSlotAvailability {
    for (const t of Object.values(events)) {
      for (const a of t.availabilities) {
        if (a.time === time) {
          return a;
        }
      }
    }
    throw new Error();
  }

  private handleClickCalendar(e: React.MouseEvent<HTMLButtonElement>) {
    const { onSubmit, events } = this.props;
    onSubmit(
      this.findEventAvailability(
        events.dates,
        parseInt(e.currentTarget.value, 10),
      ),
    );
  }

  public render() {
    const {
      loading,
      displayDates,
      events,
      postable,
      onClickToday,
      onClickPrev,
      onClickNext,
    } = this.props;

    if (displayDates.length === 0) {
      // TODO: loading（必要なら）
      return null;
    }

    const dates = displayDates.map(d => df.format(d, 'YYYY-MM-DD'));
    return (
      <div className={css.InputBookingDateTimeMarubatsu}>
        <div className={css.InputBookingDateTimeMarubatsu__ButtonContainer}>
          <BooksCalendarButton
            disabled={df.isSameDay(new Date(), dates[0])}
            customType="prev"
            value="prev"
            onClick={onClickPrev}
          />
          <BooksCalendarButton
            customType="today"
            value="today"
            onClick={onClickToday}
          />
          <BooksCalendarButton
            customType="next"
            value="next"
            onClick={onClickNext}
          />
        </div>

        <BooksCalendar
          loading={loading}
          postable={postable}
          dates={dates}
          events={events}
          onClick={this.handleClickCalendar}
        />

        <div className={css.InputBookingDateTimeMarubatsu__ButtonContainer}>
          <BooksCalendarButton
            disabled={df.isSameDay(new Date(), dates[0])}
            customType="prev"
            value="prev"
            onClick={onClickPrev}
          />
          <BooksCalendarButton
            customType="today"
            value="today"
            onClick={onClickToday}
          />
          <BooksCalendarButton
            customType="next"
            value="next"
            onClick={onClickNext}
          />
        </div>
      </div>
    );
  }
}

export default Calendar;
